import { getJson } from '../helpers/strapi';
import { ISiteBanner } from '../types';

export function getDataUrls(): string[] {
  return [`${process.env.GATSBY_API_URL}/site-banners/current`];
}

export async function fetchData(): Promise<ISiteBanner | null> {
  let siteBanner: ISiteBanner | null = null;
  // try {
  //   siteBanner = await getJson<ISiteBanner | null>('/site-banners/current');
  // } catch (e) {
  //   console.error(e);
  // }

  return siteBanner;
}
